import { isRecentlyAdded } from "../date/date";
import { simpleSort } from "../sortHelper/sortHelper";

export const getFilterWithAddedItem = (currentFilter, item) => ({
  ...currentFilter,
  ...item,
});

export const getOrFilter = (...items) => ({
  or: items,
});

export const getHomeAddressFilter = (searchQuery) => {
  if (!searchQuery || searchQuery.length <= 2 || !searchQuery.trim()) {
    return {};
  }

  return { address: { addressLine1: { contains: searchQuery } } };
};

export const buildSearchQuery = (search, fields, operator = "or") => {
  if (!search || !fields || fields.length === 0) {
    return {};
  }

  const query = {};
  fields.forEach((field) => {
    const keys = field.split(".");
    let current = query;

    keys.forEach((key, index) => {
      if (!current[key]) {
        current[key] = {};
      }
      if (index === keys.length - 1) {
        current[key] = { contains: search };
      } else {
        current = current[key];
      }
    });
  });

  return { [operator]: query };
};

export const buildQueryString = (queryObject) => {
  if (!queryObject || typeof queryObject !== "object") {
    throw new Error("Input must be an object.");
  }
  const queryParams = Object.entries(queryObject)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");

  return `?${queryParams}`;
};

export const getRecentItems = (data, numItems = 5) => {
  return data
    .filter((entity) =>
      isRecentlyAdded(entity.modifiedOn ?? entity.createdOn ?? "")
    )
    .sort((a, b) =>
      simpleSort(b.modifiedOn ?? b.createdOn, a.modifiedOn ?? a.createdOn)
    )
    .slice(0, numItems);
};

export const handleSearch = (data, search) => {
  if (search === null || data === undefined || search.trim() === "") {
    return data;
  }
  const filterByValue = (array, string) =>
    array.filter((values) =>
      Object.keys(values).some((item) => {
        if (values[item] !== undefined && typeof values[item] === "object") {
          return Object.values(values[item])
            .toString()
            .toLowerCase()
            .includes(string.toLowerCase());
        }
        if (
          values[item] !== undefined &&
          values[item].toString().toLowerCase().includes(string.toLowerCase())
        ) {
          return true;
        }
        return false;
      })
    );

  return filterByValue(data, search);
};

export const getGUIDArray = (arr) =>
  arr.map((id) => ({ type: "guid", value: id }));

export const getUniqueArrayByField = (arr, field) => {
  const seen = new Set();

  return arr.filter((item) => {
    const fieldValue = item[field];
    if (seen.has(fieldValue)) {
      return false;
    }
    seen.add(fieldValue);

    return true;
  });
};
